import {
  Component,
  OnDestroy,
  OnInit,
  Output,
  ViewEncapsulation,
  EventEmitter,
  Input,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { OpsSelectComponent } from '../ops-select/ops-select.component';
import { OpsCalendarComponent } from '../ops-calendar/ops-calendar.component';

import { Subscription } from 'rxjs';
import { EnumService } from '@ops/shared-types';
import { isString } from 'lodash-es';

@Component({
  selector: 'ops-recurring-modal',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    OpsSelectComponent,
    OpsCalendarComponent,
  ],
  templateUrl: './ops-recurring-modal.component.html',
  styleUrl: './ops-recurring-modal.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class OpsRecurringModal implements OnInit, OnDestroy {
  private _endDate?: Date | string;
  isLoading = false;
  subs: Array<Subscription> = [];

  @Input() set endDate(val: Date | string) {
    this._endDate = val;
  }
  get endDate() {
    return this._endDate;
  }

  @Input() frequency?: string;
  @Input() expectedAmount?: number;
  @Input() isCreate?: boolean;
  @Input() actionType: 'create' | 'edit' | 'convert';
  @Output() closeModal = new EventEmitter<boolean | null>();
  @Output() saveRecurring = new EventEmitter<any>();
  @Output() deleteRecurring = new EventEmitter<any>();

  frequencyOptions: Array<string> = [];

  constructor(
    private enumService: EnumService,
    private translateService: TranslateService
  ) {
    this.frequencyOptions = this.enumService.getRecurringFrequencyOptions();
  }

  ngOnInit(): void {
    this.isLoading = false;
  }

  ngOnDestroy(): void {
    this.subs.forEach((s) => s.unsubscribe());
  }

  onFrequencySelected(option: string) {
    // console.log(option);
    this.frequency = option;
    // this.checkRequirements();
  }

  closeModalHandle = () => {
    this.closeModal.emit();
  };

  saveChanges() {
    // TODO SAVE CHANGES ON PARENT
    // AS DEPENDENT OF TYPE OF CREATION
    this.isLoading = true;
    this.saveRecurring.emit({
      actionType: this.actionType,
      frequency: this.frequency,
      endDate: this.endDate,
      expectedAmount: this.expectedAmount,
    });
  }

  onDelete() {
    if (
      window.confirm(
        this.translateService.instant('windowConfirm.opsRecurringModal.deleteRecurringCost')
      )
    ) {
      this.deleteRecurring.emit();
    }
  }

  onEndDateChange(value: Date) {
    this.endDate = value;
  }

  isInvalidDate = (valToCheck: any) => {
    if (isString(valToCheck)) {
      const checkDate = new Date(valToCheck);
      if (checkDate instanceof Date && isNaN(checkDate.getTime())) {
        return true;
      }
    } else if (valToCheck instanceof Date && isNaN(valToCheck.getTime())) {
      return true;
    }
    return false;
  };

  get isValid() {
    if (this.frequency && this.endDate && !this.isInvalidDate(this.endDate)) {
      return true;
    }
    return false;
  }
}
